var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box',[(_vm.uml)?_c('plantuml',{attrs:{"uml":_vm.uml,"context-menu":_vm.contextMenu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }